module.exports = __webpack_public_path__ + "img/L1060787.8a0b26c2.jpg";